import React from "react";
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import QualifiedShareDividendRejectFormContainer from "./rejectFormContainer";
//#endregion

function useQualifiedShareDividendRejectDialog(
  onRejectSuccess?: (value?: any) => void,
  onError?: (value?: any) => void
) {
  const getRejectDialog = (id: string): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reject),
      titleIcon: IconDefinitionConstants.WCalendar,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
          successMessage: TranslationKeys.QualifiedShareDividends.QualifiedShareDividendRejectSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <QualifiedShareDividendRejectFormContainer id={id}></QualifiedShareDividendRejectFormContainer>,
      maxWidth: "sm",
      onSubmit: onRejectSuccess,
      onError: onError,
    };
  };

  return getRejectDialog;
}

export default useQualifiedShareDividendRejectDialog;
